import { render, staticRenderFns } from "./Parts.vue?vue&type=template&id=007a51e4"
import script from "./Parts.vue?vue&type=script&lang=js"
export * from "./Parts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports